import React, { useEffect, useState } from 'react';
import '../styles/UserInfo.css';
import avatar from "../assets/user_avatar.png";
import chart from "../assets/bar_graph.png";


const UserInfo = () => {

  const [user, setUser] = useState(null); //  State to hold user details
  const [loading, setLoading] = useState(true); //  Loading state
  // const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    // Fetch user data on component mount
    fetch('/api/current_user', {
      credentials: 'include', // send cookies with request
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          setUser(data); // set user data from backend
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching user info:', err);
        setLoading(false);
      });
  }, []);


  if (loading) {
    return <div>Loading user info...</div>; // Show loading while fetching
  }

  if (!user) {
    return <div>No user info available.</div>; // Show if no user data received
  }




  return (
    <div className="dashboard">
      {/*<div className="header">
        <img src="../assets/codelattice.png" alt="Logo" className="logo" />
      </div>*/}

      <div className="top-section">
        <div className="user-card">
          <img src={user.picture || avatar} alt="User Avatar" className="avatar" />
          <div className="user-info">
            <h2>{user.name || "User's Name"}</h2>
            <div className="input-row">
              <label>Email</label>
              <input type="text" value={user.email || ''} readOnly />
            </div>
            <div className="input-row">
              <label>Role</label>
              <input type="text" value={user.role || ''} readOnly />
            </div>
            {/* <div className="input-row">
              <label>Department</label>
              <input type="text" value={user.department || ''} readOnly />
            </div> */}
            <div className="input-row">
              <label>Branch</label>
              <input type="text" value={user.branch || ''} readOnly />
            </div>
            <div className="input-row">
              <label>Reporting Manager</label>
              <input type="text" value={user.reporting_manager || ''} readOnly />
            </div>

            {/* Delete Account Button */}
            {/* <div style={{ marginTop: "20px" }}>
              <button className="delete-btn" onClick={() => setShowDeleteModal(true)}>
                Delete Account
              </button>
            </div> */}
          </div>
        </div>

        <div className="qr-card">
          {user.qr_code ? (
            <img src={`data:image/png;base64,${user.qr_code}`} alt="QR Code" className="qr" />
          ) : (
            <p>No QR Code available</p>
          )}
        </div>
      </div>

      {/* <div className="chart-card">
        <img src={chart} alt="Chart" className="chart" />
      </div> */}

      {/* Delete Confirmation Modal */}
      {/* {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Confirm Account Deletion</h3>
            <p>Are you sure you want to delete your account? This action cannot be undone.</p>
            <div className="modal-buttons">
              <button onClick={handleDelete} className="confirm-delete">Yes, Delete</button>
              <button onClick={() => setShowDeleteModal(false)}>Cancel</button>
            </div>
          </div>
        </div> */}
      {/* )} */}
    </div>
  );
};

export default UserInfo;

//need pic